<template>
  <div>
    <p class="width_title">
      {{ $t('generic.width') }}
    </p>
    <div class="width-buttons">
      <button
        v-for="width in widths"
        :key="width.value"
        class="btn btn-default"
        type="button"
        :class="{
          active: width.value === selectedWidth.value,
          disabled: !width.active || !active,
        }"
        @click="updateWidth(width)"
      >
        {{ width.name }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  widths: {
    type: Array,
    default: () => [],
  },
  active: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['update:modelValue']);

const selectedWidth = ref(
  props.widths.find(width => width.value === (props.modelValue || 'standard'))
  || { name: '', value: '', active: false, }
);

function updateWidth(width) {
  selectedWidth.value = width;
  emit('update:modelValue', width.value);
}
</script>

<style lang="scss" scoped>
.width-buttons {
  button {
    margin-right: 6px;
    margin-bottom: 6px;
    min-width: 125px;
    width: 48%;
    width: calc(50% - 6px);
    font-weight: 300;
    border-radius: 2px;
    white-space: nowrap;
    text-align: center;
    box-shadow: none;
    cursor: pointer;

    &.active,
    &:active,
    &:focus,
    &:hover {
      background: #f55310;
      border: 1px solid #f55310;
      color: #fff;
      outline-style: none !important;
    }

    &.disabled {
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
</style>
